<script setup lang="ts">
import { TooltipProvider } from 'reka-ui'
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import { useBrandTheme } from '@/shared/branding/useBrandTheme'
import AppShell from '@/shared/layout/AppShell.vue'
import { useBrandingStore } from '@/stores/branding'

/**
 * Koreň aplikácie.
 *
 * Robí dve veci: zapne white-label vrstvu (brand farba partnera + odvodené
 * popredie na `<html>`, aby platila aj v portáloch) a rozhodne, či sa stránka
 * kreslí v shelle. Prihlásenie a chybové stránky shell nemajú — bez relácie
 * by v sidebare nebolo čo zobraziť.
 */
const route = useRoute()
const branding = useBrandingStore()

useBrandTheme(() => branding.brandHex)

const withShell = computed(() => route.meta.requiresAuth === true)
</script>

<template>
	<TooltipProvider :delay-duration="300">
		<AppShell v-if="withShell">
			<RouterView />
		</AppShell>
		<RouterView v-else />
	</TooltipProvider>
</template>
